import React from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';

// import `getAnimationConfig` utility function
import { getAnimationConfig } from './utils';

/**
 * @type {function}
 * @desc This HOC creates a pose (animated) component by wrapping a React View that supports accepts a ref.
 * @param {object} Vuew - A React view created using `React.forwardRef`.
 * @example
 * import { animator } from 'core/modules/animation';
 */
export const animator = ( _Component, animationName, settings = {} ) => {

    // create custom framer-motion compoment
    const Component = motion.custom( _Component );

    // get animation config using `animationName` value
    const animationConfig = isEmpty( animationName ) ? {} : getAnimationConfig( animationName, settings );

    // return component with animation
    return class AnimatedComponent extends React.Component {
        render() {
            return (
                <Component
                    { ...this.props }
                    { ...animationConfig }
                />
            );
        }
    };
};
